import script from "./SuggestedProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./SuggestedProducts.vue?vue&type=script&setup=true&lang=js"

import "./SuggestedProducts.vue?vue&type=style&index=0&id=1b20cd90&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b20cd90"]])

export default __exports__